import type { PullRequestDetail, PullRequestReviewVerdict } from "@cmmd-forge/contracts";

export function pullRequestTimelineCommentAuthor(login: string | null | undefined) {
  return login ?? "Unknown author";
}

export function pullRequestTimelineCommentTitle(kind: string) {
  return kind === "review" ? "reviewed" : "commented";
}

export function pullRequestTimelineAuthor(detail: PullRequestDetail) {
  return detail.author?.login ?? "Unknown author";
}

export function pullRequestTimelineReactionsEnabled(detail: PullRequestDetail, fresh: boolean) {
  return fresh ? detail.capabilities.reactions === true : false;
}

export function pullRequestTimelineCommentEditingEnabled(
  detail: PullRequestDetail,
  fresh: boolean,
) {
  return fresh ? detail.capabilities.edit?.comment === true : false;
}

export function pullRequestTimelineCommentingEnabled(detail: PullRequestDetail, fresh: boolean) {
  if (!fresh) return false;
  return detail.capabilities.comment ? detail.viewerPermissions.comment : false;
}

export function pullRequestTimelineReplyEnabled(detail: PullRequestDetail, fresh: boolean) {
  if (!fresh) return false;
  return detail.capabilities.review.reply ? detail.viewerPermissions.comment : false;
}

export function pullRequestTimelineResolutionEnabled(detail: PullRequestDetail, fresh: boolean) {
  if (!fresh) return false;
  return detail.capabilities.review.resolve ? detail.viewerPermissions.resolve : false;
}

/** A verdict is actionable only when both the host and the current viewer allow it. */
export function availableFreshPullRequestReviewVerdicts(
  hostVerdicts: ReadonlyArray<PullRequestReviewVerdict>,
  viewerVerdicts: ReadonlyArray<PullRequestReviewVerdict>,
  fresh: boolean,
) {
  if (!fresh) return [];
  const viewer = new Set(viewerVerdicts);
  return hostVerdicts.filter((verdict) => viewer.has(verdict));
}
